import classNames from 'classnames'
import { FC, useState } from 'react'
import { LoaderInCentalPosition } from 'widget'

import style from './ProductParamsIcon.module.scss'

type TProductParamsIcon = {
  url: string
  name: string
}
// иконка параметра продукта
export const ProductParamsIcon: FC<TProductParamsIcon> = ({ url, name }) => {
  const [isImageError, setImageError] = useState<boolean>(false)
  const [isImageLoading, setImageLoading] = useState<boolean>(true)

  const onErrorImg = () => {
    setImageError(true)
    setImageLoading(false)
  }

  const onLoadImg = () => {
    setImageLoading(false)
  }

  return (
    <div
      className={classNames(
        style.imgWrapper,
        isImageError && style.imgWrapperHide,
      )}
    >
      {isImageLoading && <LoaderInCentalPosition props={{ size: 24 }} />}
      <img
        src={url}
        alt={name}
        className={classNames(
          style.productImg,
          !isImageLoading && style.productImgVisible,
          isImageError && style.productImgError,
        )}
        onError={onErrorImg}
        onLoad={onLoadImg}
        loading='lazy'
      />
    </div>
  )
}
